/*
* Palo Alto Theme - JH Store
*
* JH: se till att RÄTT variant hamnar i varukorgen.
*
* Problem: temat uppdaterar det dolda fältet input[name="id"] först NÄR
* section-anropet till Shopify har kommit tillbaka. På mobil tar det 1-2,5
* sekunder. Trycker kunden på "Lägg i varukorg" innan dess skickas den
* FÖRRA varianten (t ex Small i stället för Large).
*
* Lösning: sätt input[name="id"] direkt vid klick, utifrån en variantkarta.
* Kartan kommer i första hand från layout/theme.liquid ([data-jh-variant-map]),
* och hämtas från /products/<handle>.js om produkten har bytts på sidan
* (syskonprodukter/färgval). Går varianten inte att slå upp låses köpknappen
* tills temat är klart, så att fel variant aldrig kan skickas.
*/

(function () {
  'use strict';

  var UNLOCK_FALLBACK_MS = 8000;
  var LOCK_ATTR = 'data-jh-locked';
  var unlockTimer = null;
  var maps = {};
  var fetching = {};

  function root() {
    return (window.theme && window.theme.routes && window.theme.routes.root) || '/';
  }

  function readInlineMap() {
    var el = document.querySelector('[data-jh-variant-map]');
    if (!el || !el.dataset.productId) return;
    try {
      maps[el.dataset.productId] = JSON.parse(el.textContent);
    } catch (e) {
      // Ignorera trasig JSON, då låses knappen i stället.
    }
  }

  // Returnerar variantkartan för produkten, och hämtar den i bakgrunden
  // första gången en ny produkt dyker upp på sidan.
  function variantMap(productInfo) {
    var productId = productInfo.dataset.productId;
    if (!productId) return null;
    if (maps[productId]) return maps[productId];

    var handle = productInfo.dataset.productHandle;
    if (!handle || fetching[handle]) return null;

    fetching[handle] = true;
    fetch(root() + 'products/' + handle + '.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        maps[String(data.id)] = data.variants.map(function (variant) {
          return { id: variant.id, options: variant.options };
        });
      })
      .catch(function () {
        // Tyst: utan karta låses knappen i stället.
      })
      .then(function () {
        delete fetching[handle];
      });

    return null;
  }

  function selectedOptionValues(variantSelects) {
    var values = [];
    variantSelects.querySelectorAll('[data-index]').forEach(function (el) {
      if (el.type === 'radio' && !el.checked) return;
      var position = parseInt(String(el.dataset.index).replace('option', ''), 10);
      if (position) values[position - 1] = el.value;
    });
    return values;
  }

  function mainForm(productInfo) {
    var section = productInfo.dataset.originalSection || productInfo.dataset.section;
    var formId = 'AddToCartForm--' + section + '-' + productInfo.dataset.productId;
    return (
      productInfo.querySelector('#' + CSS.escape(formId)) ||
      productInfo.querySelector('product-form form')
    );
  }

  function lockSubmit(productInfo) {
    productInfo.querySelectorAll('[data-add-to-cart], [data-buy-it-now]').forEach(function (button) {
      if (button.hasAttribute('disabled')) return;
      button.setAttribute('disabled', 'disabled');
      button.setAttribute(LOCK_ATTR, '');
      button.classList.add('is-loading');
    });

    clearTimeout(unlockTimer);
    unlockTimer = setTimeout(unlockSubmit, UNLOCK_FALLBACK_MS);
  }

  function unlockSubmit() {
    clearTimeout(unlockTimer);
    document.querySelectorAll('[' + LOCK_ATTR + ']').forEach(function (button) {
      button.removeAttribute('disabled');
      button.removeAttribute(LOCK_ATTR);
      button.classList.remove('is-loading');
    });
  }

  function onOptionChange(event) {
    var input = event.target.closest && event.target.closest('[data-index]');
    if (!input) return;

    var variantSelects = input.closest('variant-selects');
    if (!variantSelects) return;

    var productInfo = variantSelects.closest('product-info');
    if (!productInfo) return;

    var form = mainForm(productInfo);
    var idInput = form && form.querySelector('input[name="id"]');
    if (!idInput) return;

    // Byte till en annan produkt (syskon): temat laddar om hela produkten.
    var productUrl = input.dataset.productUrl;
    if (productUrl && productInfo.dataset.url && productUrl !== productInfo.dataset.url) {
      lockSubmit(productInfo);
      return;
    }

    var variants = variantMap(productInfo);
    if (!variants) {
      lockSubmit(productInfo);
      return;
    }

    var selected = selectedOptionValues(variantSelects);
    var variant = variants.find(function (candidate) {
      return (
        candidate.options.length === selected.length &&
        candidate.options.every(function (value, index) {
          return value === selected[index];
        })
      );
    });

    if (!variant) {
      lockSubmit(productInfo);
      return;
    }

    if (idInput.value === String(variant.id)) return;

    idInput.value = String(variant.id);
    idInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function onProductInfoLoaded(event) {
    unlockSubmit();
    if (event.target && event.target.dataset) variantMap(event.target);
  }

  readInlineMap();
  document.querySelectorAll('product-info').forEach(variantMap);

  document.addEventListener('change', onOptionChange, true);
  document.addEventListener('theme:product-info:loaded', onProductInfoLoaded);

  if (typeof window.subscribe === 'function' && window.theme && window.theme.PUB_SUB_EVENTS) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, unlockSubmit);
  }
})();

/*
 * JH: AOV-appens varukorgslåda (aov.ai) byter ut innehållet i temats låda
 * (cart-items[data-cart-drawer]), så elementet [data-cart-errors] försvinner. Temats
 * closeCartDrawer() kraschar då på this.cartErrorHolder.classList, lådan står kvar som
 * öppen och scroll-låset släpps aldrig: på mobilen går sidan inte att scrolla efter att
 * varukorgen stängts, förrän man råkar trycka någonstans. Temat sätter om egenskapen vid
 * varje omritning, så den görs till en getter som aldrig blir null.
 */
(function () {
  'use strict';

  var fallback = document.createElement('div');

  function patch(drawer) {
    if (!drawer || drawer.jhErrorHolderPatched) return;
    drawer.jhErrorHolderPatched = true;
    Object.defineProperty(drawer, 'cartErrorHolder', {
      configurable: true,
      get: function () {
        return this.querySelector('[data-cart-errors]') || fallback;
      },
      set: function () {}
    });
  }

  patch(document.querySelector('cart-items[data-cart-drawer]'));
  document.addEventListener('theme:cart:loaded', function () {
    patch(document.querySelector('cart-items[data-cart-drawer]'));
  });
})();
